import { createResource } from "solid-js";
import { api } from "../api";
import { forgetMe, knownMe, loadMe } from "./me";

const [me, { refetch, mutate }] = createResource(loadMe);

export const session = {
  me,
  refetch,
  signedIn: () => !!me(),
  /** Resolves once the session is known (null = signed out): route only after this. */
  known: knownMe,
  signOut: async () => {
    await api.post("/auth/logout");
    forgetMe();
    mutate(null);
  },
};

export { nextStepFor } from "./steps";
